"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsMethods = PaymentsMethods;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const DeletePaymentMethodModal_1 = __importDefault(require("./DeletePaymentMethodModal"));
const DangerButton = (0, styled_components_1.default)(elements_1.Button) `
	background-color: ${({ theme }) => theme.color.error} !important;
	border-color: ${({ theme }) => theme.color.error} !important;

	&:hover {
		background-color: ${({ theme }) => theme.color.error};
		border-color: ${({ theme }) => theme.color.error};
	}
`;
function PaymentsMethods() {
    // const [isAddPaymentMethodModalOpen, setIsAddPaymentMethodModalOpen] = React.useState(false)
    const [isDeletePaymentMethodModalOpen, setIsDeletePaymentMethodModalOpen] = react_1.default.useState(false);
    const { data: paymentMethods, isPlaceholderData: isPlaceholderPaymentMethodsData } = (0, useAppQuery_1.useAppQuery)([queries_1.Queries.getPaymentMethods], Api.Admin.getPaymentMethods, {
        placeholderData: [],
    });
    const hasPaymentMethod = paymentMethods.length > 0;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [hasPaymentMethod &&
                paymentMethods.map(paymentMethod => ((0, jsx_runtime_1.jsxs)("div", { className: "p-m flex-row align-center justify-space-between", children: [(0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.payment_methods.payment_card" }), paymentMethod.expired && ((0, jsx_runtime_1.jsx)(antd_1.Tag, { className: "m-l-m", color: "error", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.payment_methods.expired" }) }))] }), (0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("img", { className: "m-r-m", src: paymentMethod.imageUrl, alt: "Typ Karty" }), paymentMethod.maskedNumber] }), (0, jsx_runtime_1.jsx)(DangerButton, { size: "middle", onClick: () => setIsDeletePaymentMethodModalOpen(true), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.payment_methods.remove_card" }) })] }, `payment-method-${paymentMethod.maskedNumber}`))), !hasPaymentMethod && !isPlaceholderPaymentMethodsData && ((0, jsx_runtime_1.jsx)("div", { className: "flex-center p-m", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex-col", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.no_payment_methods_added" }), (0, jsx_runtime_1.jsx)("div", { className: "text-center" })] }) })), (0, jsx_runtime_1.jsx)(DeletePaymentMethodModal_1.default, { isDeletePaymentMethodModalOpen: isDeletePaymentMethodModalOpen, setIsDeletePaymentMethodModalOpen: setIsDeletePaymentMethodModalOpen })] }));
}
